import React, { Fragment, useState } from 'react';
import List from "@mui/material/List";
import ListItem from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { Link, useLocation } from "react-router-dom";

const menus = [
    {
        id: 1,
        title: 'Service',
        link: '/service',
        submenu: [
            {
                id: 2,
                title: 'Cloud File Storage',
                link: '/#cloud-file-storage'
            },
            {
                id: 3,
                title: 'Cloud PC',
                link: '/#cloud-pc'
            },
            {
                id: 4,
                title: 'Cloud Surveillance',
                link: '/#cloud-surveillance'
            },
            {
                id: 5,
                title: 'Cloud File Transfer',
                link: '/#cloud-file-transfer'
            }
        ]
    },
    {
        id: 6,
        title: 'Plans',
        link: '/plans',
        submenu: [
            {
                id: 7,
                title: 'Individual Plans',
                link: '/individual-plans'
            },
            {
                id: 8,
                title: 'Enterprise Plans',
                link: '/enterprise-plans'
            },
            {
                id: 9,
                title: 'Lifetime Plans',
                link: '/lifetime-plans'
            }
        ]
    },
    {
        id: 10,
        title: 'About Us',
        link: '/about',
    },
    {
        id: 11,
        title: 'Contact Us',
        link: '/contact',
    }
]

const MobileMenu = ({ setMobailState = "" }) => {
    const location = useLocation();
    const [openId, setOpenId] = useState(0);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
        setMobailState(null)
    }

    return (
        <ul className="main_menu_list clearfix">
            {menus.map((item, mn) => {
                return (
                    <ListItem className={item.id === openId ? 'active' : null} key={mn}>
                        {item.submenu ?
                            <Fragment>
                                <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>{item.title}
                                    <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                                </p>
                                <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                                    <List className="subMenu">
                                        <Fragment>
                                            {item.submenu.map((submenu, i) => {
                                                return (
                                                    <ListItem key={i}>
                                                        <Link className={location.pathname === submenu.link ? "active-link" : ""} onClick={ClickHandler}
                                                            to={submenu.link}>{submenu.title}</Link>
                                                    </ListItem>
                                                )
                                            })}
                                        </Fragment>
                                    </List>
                                </Collapse>
                            </Fragment>
                            : <Link className={location.pathname === item.link ? "active-link" : ""} onClick={ClickHandler}
                                to={item.link}>{item.title}</Link>
                        }
                    </ListItem>
                )
            })}
        </ul>
    )
}

export default MobileMenu;